import { PrivateBillCostCenter } from "@/Common/Components/Billing/PrivateBillCostCenter";

interface ICostCenterSectionProps {
    costCenters: PrivateBillCostCenter[]
}

function CostCenterSection(props: ICostCenterSectionProps): JSX.Element {
    const costCenters = props.costCenters;

    return (
        <div>
            <div className="view-section-header">
                <h3 className="view-section-title">Cost Centers</h3>
            </div>
            <div className="view-section-body">
                {costCenters.map((costCenter: PrivateBillCostCenter, idx: number) => (
                    <div id={"__i" + idx} key={"__k" + idx} style={{ paddingBottom: "10px" }}>
                        <div className="row">
                            <div className="col-lg-4 col-md-2 col-sm-2 text-right">
                                <label className="form-label">{cacheStore.GetString("NameLabel")}</label>
                            </div>
                            <div className="col-lg-5 col-md-6 col-sm-6 form-field-answer">
                                <strong>{costCenter.Name}</strong>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-4 col-md-2 col-sm-2 text-right">
                                <label className="form-label">{cacheStore.GetString("ClinicalCodeLabel")}</label>
                            </div>
                            <div className="col-lg-5 col-md-6 col-sm-6 form-field-answer">
                                <strong>{costCenter.Code}</strong>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default CostCenterSection;
